/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export type ServerlessModel = {
  id: string;
  name: string;
  thumbnail: string;
  companyLogo: string;
  type: ServerlessModelType;

  price: { value: number; unit: string };
  info: ServerlessMoreInfoItem;

  [key: string]: unknown;
};

export enum ServerlessModelType {
  Completion = 'COMPLETION',
  Chat = 'CHAT',
  ImageGeneration = 'IMAGE_GENERATION',
}

export interface ServerlessMoreInfoItem {
  id: string;
  license: ServerlessMoreInfoLink;
  policy?: ServerlessMoreInfoLink;
  modelCard: ServerlessMoreInfoLink;
}

export interface ServerlessMoreInfoLink {
  label: string;
  link: string;
}
